import React from 'react';
import { NavLink } from 'react-router-dom';

import Aux from "../../hoc/_Aux";


import { connect } from 'react-redux'
import withRouter from '../../App/components/withRouter';
import { PORTAL_USER_ACTIVATION_VERIFY_CHANGE_PASSWD, PORTAL_USER_ACTIVATION_VERIFY_EMAIL, SET_USER_ACTIVATION_ERROR_MESSAGE, RESEND_ACTIVATION_LINK_BY_USER, RESET_PORTAL_USER_PASSWORD, SET_USER_RESET_PASSWORD_ERROR_MESSAGE, SET_LOGIN_AUTH_ERROR } from '../../store/actions/auth';
import queryString from 'query-string'
import Footer from "../../App/layout/AdminLayout/Footer"


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { portalLogoUrl } from '../../helper/utils';
import Timer from "../Utils/Timer";
import { PORTAL_INSTANCE } from '../..';
import './style-custom.scss';
import { PSWDRGX, isValidPasswd } from '../../helper/common';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';


const mapStateToProps = state => {
  return {
    isResendActivationRequired: state.auth.isResendActivationRequired,
    selectedPortalLogo: state.portal.selectedPortalLogo,
    isSetPasswordEnabled: state.auth.isSetPasswordEnabled,
    userActivateErrorMessage: state.auth.userActivateErrorMessage,
    isResendActivationSuccess: state.auth.isResendActivationSuccess,
    userResetPasswordErrorMessage: state.auth.userResetPasswordErrorMessage
  }
}

const mapDispatchToProps = {
  PORTAL_USER_ACTIVATION_VERIFY_CHANGE_PASSWD: (payload) => PORTAL_USER_ACTIVATION_VERIFY_CHANGE_PASSWD(payload),
  PORTAL_USER_ACTIVATION_VERIFY_EMAIL: (payload) => PORTAL_USER_ACTIVATION_VERIFY_EMAIL(payload),
  SET_USER_ACTIVATION_ERROR_MESSAGE: (message) => SET_USER_ACTIVATION_ERROR_MESSAGE(message),
  RESEND_ACTIVATION_LINK_BY_USER: (payload) => RESEND_ACTIVATION_LINK_BY_USER(payload),
  RESET_PORTAL_USER_PASSWORD: (payload) => RESET_PORTAL_USER_PASSWORD(payload),
  SET_USER_RESET_PASSWORD_ERROR_MESSAGE: (payload) => SET_USER_RESET_PASSWORD_ERROR_MESSAGE(payload),
  SET_LOGIN_AUTH_ERROR: (payload) => SET_LOGIN_AUTH_ERROR(payload),
}


class MailVerifyUser extends React.Component {

  constructor(props) {
    super(props);
    const params = queryString.parse(this.props.location.search)
    let { cId, pId } = PORTAL_INSTANCE
    this._isMounted = false;
    this.state = {
      portalId: pId,
      clientId: cId,
      username: params.username,
      token: params.token,

      //FORM
      code: '',
      password: '',
      confirmPassword: '',
      verifyCode: '',

      error: '',

      isSetPasswordEnabled: this.props.location.pathname === '/home/portal-account-verify',
      isResetPassword: this.props.location.pathname === '/home/reset-password',

      isTermsAccepted: true,

      showHint: false,
      isInvalidPass: true,
      errorChangePass: '',
    }
  }

  componentDidMount = async () => {
    this._isMounted = true;
    const { username, portalId, clientId, token, isResetPassword, isSetPasswordEnabled } = this.state
    if ((!username || !portalId || !clientId || !token) && !isResetPassword) {
      if (this._isMounted) {
        this.setState({ error: `User Activation Link is not Authorized. Please Contact Admin` })
      }
    }
    if (isResetPassword) {
      console.log('User reset password from email link', isSetPasswordEnabled)
    } else {
      console.log('User first time access, need to be set password by email activation link', isSetPasswordEnabled)
      const payload = {
        portalId,
        clientId,
        username,
        token
      }
      await this.props.PORTAL_USER_ACTIVATION_VERIFY_EMAIL(payload)
      if (!this._isMounted) return;
      if (this.props.userActivateErrorMessage) {
        const errorMsg = typeof this.props.userActivateErrorMessage === 'string' 
          ? this.props.userActivateErrorMessage 
          : (this.props.userActivateErrorMessage?.message || JSON.stringify(this.props.userActivateErrorMessage) || 'An error occurred')
        
        if (this.props.isSetPasswordEnabled || isResetPassword) {
          this.setState({ errorChangePass: errorMsg })
        } else {
          this.setState({ error: errorMsg })
        }
        return this.props.SET_USER_ACTIVATION_ERROR_MESSAGE(null)
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!this._isMounted) {
      return false;
    }
    return true;
  }

  componentWillUnmount = () => {
    this._isMounted = false;
        
    if (this.redirectTimeout) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = null;
    }
    
    try {
      toast.dismiss();
    } catch (error) {
      console.warn('Error dismissing toast:', error);
    }
  }

  hintMsgs = [
    {
      chk: (text) => { return (text && text.trim().length >= 8) },
      msg: '8 Characters'
    },
    {
      chk: (text) => { return (text && /(?=.*[A-Z])/.test(text)) },
      msg: '1 Uppercase letter'
    },
    {
      chk: (text) => { return (text && /(?=.*[a-z])/.test(text)) },
      msg: '1 Lowercase letter'
    },
    {
      chk: (text) => { return (text && /(?=.*\d)/.test(text)) },
      msg: '1 Digit'
    },
    {
      chk: (text) => { return (text && /(?=.*[\W\-_])/.test(text)) },
      msg: '1 Special character'
    },
  ]

  validatePasswd = async (username, newPassword, newPassword2, code) => {
    const { isResetPassword } = this.state
    let hintMsgs = this.hintMsgs
    let isValidPass = isValidPasswd(newPassword)
    let isMatchPass = (newPassword === newPassword2)
    let isSame = (newPassword === code)

    for (let a of hintMsgs) {
      a.isValid = a.chk(newPassword)
    }
    let showHint = true
    let isInvalidPass = !isValidPass || !isMatchPass || isSame || !username || !code
    let errorChangePass = ''
    if (!username) {
      errorChangePass = 'Username is required'
    } else if (!code) {
      errorChangePass = (isResetPassword ? `Current Password is required` : `Temporary code is required`)
    } else if (!isMatchPass && newPassword2) {
      errorChangePass = ('Not matched new password')
    } else if (isSame) {
      errorChangePass = ('Can NOT change to the same password')
    } else {
      errorChangePass = ''
    }
    if (this._isMounted) {
      this.setState({
        showHint, isInvalidPass, errorChangePass
      })
    }
    return !isInvalidPass
  }

  onHandleValidation = () => {
    const { username, password, confirmPassword, code } = this.state
    return this.validatePasswd(username, password, confirmPassword, code)
  }

  onChangeInput = (event) => {
    if (!this._isMounted) return;
    this.setState({
      error: ''
    })
    const { name, value } = event.target
    if (this._isMounted) {
      this.setState({ [name]: value }, () => {
        if (this._isMounted) {
          this.onHandleValidation()
        }
      })
    }
  }
  redirectTo = (url, delay = 0) => {
    this.redirectTimeout = setTimeout(() => {
      this.props.navigate(url)
    }, delay);
  }

  onChangePassword = async () => {
    const { password, confirmPassword, username, code, portalId, clientId, token, isTermsAccepted, isResetPassword } = this.state
    let isValid = this.validatePasswd(username, password, confirmPassword, code)
    if (!isValid) {
      return
    }
    if (!isTermsAccepted) {
      return this.setState({ error: `Please Read and Appove Privacy policy and  Terms of use` })
    }

    if (isResetPassword) {
      this._onResetPassword()
      return
    }

    this.setState({ error: '' })
    const payload = {
      password,
      code,
      username,
      token,
      portalId,
      clientId
    }
    try {
      await this.props.PORTAL_USER_ACTIVATION_VERIFY_CHANGE_PASSWD(payload)

      if (!this._isMounted) return;

      if (this.props.userActivateErrorMessage) {
        const errorMsg = typeof this.props.userActivateErrorMessage === 'string' 
          ? this.props.userActivateErrorMessage 
          : (this.props.userActivateErrorMessage?.message || JSON.stringify(this.props.userActivateErrorMessage) || 'An error occurred')
        
        if (this.props.isSetPasswordEnabled || isResetPassword) {
          this.setState({ errorChangePass: errorMsg })
        } else {
          this.setState({ error: errorMsg })
        }
        return this.props.SET_USER_ACTIVATION_ERROR_MESSAGE(null)
      }

      this.setState({
        isAccountVerify: true,
        password: '', code: '', confirmPassword: ''
      })

      toast.success(`The new password is set, please do "Login" now!`)
      this.redirectTo(`/login?pId=${portalId}&cId=${clientId}`, 6000)
    } catch (error) {
      if (!this._isMounted) return;
      const errorMsg = error?.message && typeof error.message === 'string' 
        ? error.message 
        : 'An unexpected error occurred. Please try again.'
      this.setState({ errorChangePass: errorMsg })
    }
  }

  _onResetPassword = async () => {
    const { password, username, code, portalId, clientId, isResetPassword } = this.state

    this.setState({ error: '' })

    const payload = {
      newPassword: password,
      password: code,
      username,
      portalId,
      clientId
    }
    try {
      await this.props.RESET_PORTAL_USER_PASSWORD(payload)

      if (!this._isMounted) return;

      if (this.props.userResetPasswordErrorMessage) {
        const errorMsg = typeof this.props.userResetPasswordErrorMessage === 'string' 
          ? this.props.userResetPasswordErrorMessage 
          : (this.props.userResetPasswordErrorMessage?.message || JSON.stringify(this.props.userResetPasswordErrorMessage) || 'An error occurred')
        
        if (this.props.isSetPasswordEnabled || isResetPassword) {
          this.setState({ errorChangePass: errorMsg })
        } else {
          this.setState({ error: errorMsg })
        }
        return this.props.SET_USER_RESET_PASSWORD_ERROR_MESSAGE(null)
      }

      this.setState({
        successMessage: `Reset Password is successful!`
      })
      this.props.SET_LOGIN_AUTH_ERROR(null)

      this.redirectTo(portalId && clientId ? `/login?pId=${portalId}&cId=${clientId}` : '/login', 6000)
    } catch (error) {
      if (!this._isMounted) return;
      const errorMsg = error?.message && typeof error.message === 'string' 
        ? error.message 
        : 'An unexpected error occurred. Please try again.'
      this.setState({ errorChangePass: errorMsg })
    }
  }

  onResendActivation = async () => {
    const { username, portalId, clientId, token } = this.state
    if (!portalId || !clientId || !token) {
      return this.setState({ error: `Please Provide All required Fields` })
    }

    const payload = {
      username,
      token,
      portalId,
      clientId
    }
    this.setState({ onResendLoading: true })
    await this.props.RESEND_ACTIVATION_LINK_BY_USER(payload)
    if (this._isMounted) {
      this.setState({ onResendLoading: false })
    }

    if (!this._isMounted) return;

    if (this.props.userActivateErrorMessage) {
      const errorMsg = typeof this.props.userActivateErrorMessage === 'string' 
        ? this.props.userActivateErrorMessage 
        : (this.props.userActivateErrorMessage?.message || JSON.stringify(this.props.userActivateErrorMessage) || 'An error occurred')
      
      this.setState({
        error: errorMsg
      })
      return this.props.SET_USER_ACTIVATION_ERROR_MESSAGE(null)
    }

    if (this.props.isResendActivationSuccess) {
      this.redirectTo(`/login?pId=${portalId}&cId=${clientId}`, 6000)
    }
  }

  render() {
    if (!this._isMounted) {
      return null;
    }
    
    const { isResetPassword } = this.state
    const isPassChange = (this.props.isSetPasswordEnabled || isResetPassword)
    return (
      <Aux>
        {/* Prevent browser auto-translate from mutating DOM inside password form (can cause removeChild errors) */}
        <div className="auth-wrapper notranslate" translate="no">
          <img src={portalLogoUrl()} alt="Logo" className="login-bg" />
          <div className="auth-content notranslate" translate="no">
            <div className="auth-bg">

            </div>
            <div className="card">
              {
                (isPassChange ? (
                  <div className="card-body notranslate" translate="no">
                    <div className="text-center mt-1 mb-2">
                      <img src={portalLogoUrl()} alt="Logo" height="6.25rem" width="9.375rem" />
                    </div>

                    <h3 className="text-center">{isResetPassword ? 'Reset Password' : 'Set New Password'}</h3>
                    <div className="input-group mt-4">
                      <input type="text" className="form-control cp-input-box notranslate" translate="no" placeholder="Username" id="username" name="username" value={this.state.username} required onChange={this.onChangeInput} disabled />
                    </div>

                    <div className="input-group mt-4">
                      <input type={this.state.isShowTempCode ? 'text' : 'password'} className="form-control cp-input-box notranslate" translate="no" style={{ borderRight: 'none' }} placeholder={isResetPassword ? 'Current Password *' : 'Temporary code *'} name="code" id="code" value={this.state.code} required onChange={this.onChangeInput} autoFocus />

                      <span className="input-group-text notranslate" translate="no" style={{ background: "none", color: 'black' }} onClick={() => { this.setState({ isShowTempCode: !this.state.isShowTempCode }) }}>{this.state.isShowTempCode ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}</span>
                    </div>

                    <div className="input-group mt-4">
                      <input type={this.state.isShowPwd ? 'text' : 'password'} className="form-control cp-input-box notranslate" translate="no" style={{ borderRight: 'none' }} placeholder={isResetPassword ? 'New Password *' : 'New Password *'} pattern={PSWDRGX} title="" name="password" id="inputPassword" value={this.state.password} required onChange={this.onChangeInput} />

                      <span className="input-group-text notranslate" translate="no" style={{ background: "none", color: 'black' }} onClick={() => { this.setState({ isShowPwd: !this.state.isShowPwd }) }}>{this.state.isShowPwd ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}</span>
                    </div>

                    <Form.Text id="newPassword12" muted>
                      {Array.isArray(this.hintMsgs) && this.hintMsgs.length > 0 && this.hintMsgs.map((a, idx) => (
                          <span key={a.msg || idx} className={`password-hint notranslate ${this.state.showHint && (a.isValid ? 'success' : 'error')}`} translate="no">
                            {a.isValid ?
                              <i className="fa fa-check" aria-hidden="true"></i> :
                              <i className="fa fa-times" aria-hidden="true"></i>
                            }
                            &nbsp;
                            {a.msg} &nbsp;</span>
                      ))}
                    </Form.Text>

                    <div className="input-group mt-4">
                      <input type={this.state.isShowConfirmPwd ? 'text' : 'password'} className="form-control cp-input-box notranslate" translate="no" style={{ borderRight: 'none' }} placeholder={isResetPassword ? 'Confirm New Password *' : 'Confirm Password *'} name="confirmPassword" id="confirmInputPassword" value={this.state.confirmPassword} required onChange={this.onChangeInput} />

                      <span className="input-group-text notranslate" translate="no" style={{ background: "none", color: 'black' }} onClick={() => { this.setState({ isShowConfirmPwd: !this.state.isShowConfirmPwd }) }}>{this.state.isShowConfirmPwd ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}</span>
                    </div>

                    <Form.Text id="newPassword22" muted>
                      {this.state.errorChangePass ? (
                        <span className={`password-hint error`}>
                          <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                          &nbsp;
                          {this.state.errorChangePass}
                        </span>
                      ) : <span className={`password-hint`}> &nbsp; </span>}
                    </Form.Text>


                    {this.state.showTerm ? <div className="form-group text-start mt-4">
                      <div className="checkbox checkbox-fill d-inline">
                        <input type="checkbox" name="checkbox-fill-1" id="checkbox-fill-a1" checked={this.state.isTermsAccepted} onChange={() => { this.setState({ error: '', isTermsAccepted: !this.state.isTermsAccepted }) }} />
                        <label htmlFor="checkbox-fill-a1" className="cr1"> I accept <NavLink to={`/privacypolicy${this.props.location.search}`} disabled={this.state.isLoading || this.props.session}>Privacy Policy </NavLink> and <NavLink to={`/terms${this.props.location.search}`}>Terms </NavLink></label>
                      </div>
                    </div> : <div>&nbsp;</div>}

                    <div className="text-center">
                      <Button color="primary" className="btn-block" size="lg" disabled={this.state.isInvalidPass || this.state.isLoading || this.props.session} onClick={this.onChangePassword}>
                        <span style={{ "marginRight": "0.625rem" }} >
                          {this.state.isLoading ? (<FontAwesomeIcon icon={faSpinner} spin />) : null}
                        </span>
                        {isResetPassword ? 'Reset Password' : 'Create New Password'}
                      </Button>
                    </div>
                  </div>
                ) : null)
              }
              {
                (this.props.isResendActivationRequired ? (
                  <div className="card-body text-center">
                    {/* <div className="text-center mt-1 mb-2">
                      <img src={portalLogoUrl()} alt="Logo" height="6.25rem" width="9.375rem" />
                    </div> */}

                    <div className="title text-center mb-2">
                      <i className="fa fa-exclamation-circle icon-warning" aria-hidden="true"></i>
                    </div>

                    <div className="alert alert-msg text-dark">
                      <div>Your Account Activation link is Expired! <br />
                        Please click on the button below to get a new one</div>
                      <div className="text-center mt-3">
                        <Button color="primary" className="btn-block" size="lg" onClick={this.onResendActivation}
                          disabled={this.state.onResendLoading}>
                          Resend Activation
                        </Button>
                      </div>
                      {/* <div className="text-center">
                        <span style={{ "marginRight": "0.625rem", color: "blue", fontSize: "1.875rem" }} >
                          {this.state.onResendLoading ? (<FontAwesomeIcon icon={faSpinner} spin />) : null}
                        </span>
                      </div> */}
                    </div>
                  </div>
                ) : null)
              }

              {
                this.props.isResendActivationSuccess ? (
                  <div className="card-body text-center">
                    {/* <div className="text-center mt-1 mb-2">
                      <img src={portalLogoUrl()} alt="Logo" height="6.25rem" width="9.375rem" />
                    </div> */}

                    <div className="title text-center mb-2">
                      <i className="fa fa-check-circle icon-succ" aria-hidden="true"></i>
                    </div>

                    <div className="alert alert-msg text-dark">
                      <div>We have sent the activation mail to your Registered Email.</div>
                      <div>Please check your mail and Activate your account.</div>
                      <div className="text-center">
                        <span style={{ "marginRight": "0.625rem" }} >
                          {this.state.onResendLoading ? (<FontAwesomeIcon icon={faSpinner} spin />) : null}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : null
              }

              {
                (!this.props.isSetPasswordEnabled && !this.state.error && !this.props.isResendActivationRequired && !this.props.isResendActivationSuccess) && !isResetPassword ? (
                  <div className="card-body text-center">
                    We are Verifying Your Account, Please Wait...
                  </div>
                ) : null
              }
              {
                this.state.isAccountVerify ? <div className="card-body text-center">
                  Your Account is Activated,Please  <span onClick={() => { this.props.navigate(`/login?pId=${this.state.portalId}&cId=${this.state.clientId}`) }} style={{ cursor: "pointer", color: "green", textDecoration: "underline" }}>Login here</span>
                </div> : null
              }

              {
                this.state.error && (
                  <div className="card-body card-msg text-center">
                    {/* <div className="text-center mt-1 mb-2">
                      <img src={portalLogoUrl()} alt="Logo" height="6.25rem" width="9.375rem" />
                    </div> */}

                    <div className="title text-center mb-2">
                      <i className="fa fa-exclamation-circle icon-warning" aria-hidden="true"></i>
                    </div>
                    <div className="alert alert-msg text-dark"> {this.state.error} </div>
                    <div>Back to <span onClick={() => { this.props.navigate(`/login?pId=${this.state.portalId}&cId=${this.state.clientId}`) }} style={{ cursor: "pointer", color: "green", textDecoration: "underline" }}> Login</span> page</div>
                  </div>
                )
              }

              {
                !this.state.error && this.state.successMessage && isResetPassword && (

                  <div className="card-body card-msg text-center">
                    {/* <div className="text-center mt-1 mb-2">
                      <img src={portalLogoUrl()} alt="Logo" height="6.25rem" width="9.375rem" />
                    </div> */}

                    <div className="title text-center mb-2">
                      <i className="fa fa-check-circle icon-succ" aria-hidden="true"></i>
                    </div>
                    <div className="alert alert-msg text-dark">
                      <div className="mb-2"> {this.state.successMessage} </div>
                      <div>
                        <span className="text-info">Back to login page in
                          <Timer initialMinute={0} initialSecond={10} isTimerClosed={0}></Timer> sec</span>
                      </div>
                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </div>
        <Footer search={this.props.location.search} />

      </Aux>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MailVerifyUser));